import { Popup } from "antd-mobile";
import styled from "styled-components";
import useNavigation from "../../hooks/useNavigation";

const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 16px 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-top: 1px solid rgb(200, 200, 200);
  cursor: pointer;
  font-size: 16px;
`;

const Close = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  color: rgb(200, 200, 200);
  cursor: pointer;
`;

const MENUS = [
  { key: "PayAccountManage", label: "收付款管理" },
  { key: "SettingPayNumber", label: "支付密码" },
  { key: "Verified", label: "实名认证" },
];

type Props = {
  visible: boolean;
  setVisible: (v: boolean) => void;
};

const TopRightMenuModal = ({ visible, setVisible }: Props) => {
  const { navigate } = useNavigation();

  return (
    <Popup
      visible={visible}
      onMaskClick={() => setVisible(false)}
      bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, paddingBottom: 40 }}
    >
      <div style={{ position: "relative" }}>
        <Close onClick={() => setVisible(false)}>关闭</Close>
        <Title>菜单</Title>
        {MENUS.map((m) => (
          <Row
            key={m.key}
            onClick={() => {
              setVisible(false);
              navigate(m.key);
            }}
          >
            <span>{m.label}</span>
            <span style={{ color: "#000" }}>›</span>
          </Row>
        ))}
      </div>
    </Popup>
  );
};

export default TopRightMenuModal;
